import { render, staticRenderFns } from "./quarter1.vue?vue&type=template&id=b05ee2cc&"
import script from "./quarter1.vue?vue&type=script&lang=js&"
export * from "./quarter1.vue?vue&type=script&lang=js&"
import style0 from "./quarter1.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports